import React from "react";
import "./AboutStyle.css";
const AboutSection = () => {
  return (
    <section className="about" id="about">
      <div className="container">
        <div className="content">
          <div className="image-side">
            <img src="./Images/about.jpg" alt="" />
          </div>
          <div className="text-side">
            <h3>About me</h3>
            <br />
            <h4>
              A dedicated Front-end Developer based in Peshawar, Pakistan. 📍
            </h4>
            <p>
              As a Junior Front-End Developer, I possess an impressive arsenal
              of skills in HTML, CSS, JavaScript, React, and Bootstrape also ant Desigen. I
              excel in designing and maintaining responsive websites that offer
              a smooth user experience. My expertise lies in crafting dynamic,
              engaging interfaces through writing clean and optimized code. I am also
              a student studing Software Engineering from Virtual Universty of Pakistan.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
